import { useState, RefObject } from "react";
import type { MachineEvent } from "@/machines/types/event";

export interface EventSegment {
  start: number;
  end: number;
  color: string;
  event?: MachineEvent;
  trackKey?: string;
  trackHeight?: number;
  isAlert?: boolean;
  hidden?: boolean;
  /** Arrived after the initial load (live poll) — plays the pop-in animation. */
  isNew?: boolean;
}

interface UseTimelineEventsProps {
  svgRef: RefObject<SVGSVGElement>;
}

export const useTimelineEvents = ({ svgRef }: UseTimelineEventsProps) => {
  const [hoveredEvent, setHoveredEvent] = useState<EventSegment | null>(null);
  const [hoverPos, setHoverPos] = useState<{ x: number; y: number } | null>(null);

  /**
   * Handle event segment mouse enter
   */
  const handleEventEnter = (e: React.MouseEvent, segment: EventSegment) => {
    const svgRect = svgRef.current?.getBoundingClientRect();
    setHoveredEvent(segment);
    setHoverPos({
      x: e.clientX - (svgRect?.left ?? 0),
      y: e.clientY - (svgRect?.top ?? 0),
    });
  };

  /**
   * Handle event segment mouse leave
   */
  const handleEventLeave = () => {
    setHoveredEvent(null);
    setHoverPos(null);
  };

  /**
   * Handle SVG mouse leave (clears hover)
   */
  const handleSVGMouseLeave = () => {
    setHoveredEvent(null);
    setHoverPos(null);
  };

  return {
    hoveredEvent,
    hoverPos,
    handleEventEnter,
    handleEventLeave,
    handleSVGMouseLeave,
  };
};
